import { toast } from "react-toastify";
import crypto from "../../Crypto";
export const createHandleAuditoriaKeyDown = ({
  auditingRows,
  updateAuditoria,
  setMotivoRow,
  setMotivoModalOpen,
  aprobarRechazar,
  selectedRow,
  selectionModel,
  setPacienteSeleccionado,
  modoAuditoria,
}) => {
  return (params, event) => {
    const row = params.row;
    const rowId = params.id;
    const tratamientoId = row.tratamiento_id;

    if (event.key === "F4") {
      event.preventDefault();
      if (!modoAuditoria) {
        toast.warning("No estás en modo auditoría");
        return;
      }
      // Si está en modo vista, no hacer nada
      const filaActual = auditingRows.find(
        (r) => r.tratamiento_id === tratamientoId
      );
      if (filaActual?.auditando) return;

      updateAuditoria({
        auditingRows: auditingRows.map((r) =>
          r.tratamiento_id === tratamientoId ? { ...r, auditando: true } : r
        ),
      });

      aprobarRechazar({ row, tipo: "aprobar" }).then((updated) => {
        if (updated && updated.error === false && updated.listado) {
          updateAuditoria({
            auditingRows: auditingRows.map((r) =>
              r.tratamiento_id === updated.listado.id
                ? {
                    ...r,
                    resultado_auditoria: updated.listado.resultado_auditoria,
                    auditando: false,
                  }
                : r
            ),
          });
        } else {
          updateAuditoria({
            auditingRows: auditingRows.map((r) =>
              r.tratamiento_id === tratamientoId
                ? { ...r, auditando: false }
                : r
            ),
          });
        }
      });
    }

    if (event.key === "F5") {
      event.preventDefault();
      if (!modoAuditoria) {
        toast.warning("No estás en modo auditoría");
        return;
      }
      const fila = auditingRows.find((r) => r.tratamiento_id === tratamientoId);
      if (fila?.auditando) return;

      setMotivoRow(row);
      setMotivoModalOpen(true);
    }

    if (event.key === "F7") {
      event.preventDefault();
      updateAuditoria({
        selectionModel: selectionModel.includes(rowId)
          ? selectionModel.filter((id) => id !== rowId)
          : [...selectionModel, rowId],
      });
    }

    // 🔽 ArrowDown
    if (event.key === "ArrowDown") {
      event.preventDefault();
      const index = auditingRows.findIndex(
        (r) => r.tratamiento_id === selectedRow.tratamiento_id
      );
      console.log("Index:", index);
      console.log("SelectedRowId:", selectedRow.id);
      if (index >= 0 && index < auditingRows.length - 1) {
        const next = auditingRows[index + 1];
        crypto.encryptDataStorage("searchpatient", next.paciente_id);
        updateAuditoria({
          selectedRow: next,
          selectionModel: [next.tratamiento_id],
        });
      }
    }

    // 🔼 ArrowUp
    if (event.key === "ArrowUp") {
      event.preventDefault();
      const index = auditingRows.findIndex(
        (r) => r.tratamiento_id === selectedRow.tratamiento_id
      );
      if (index > 0) {
        const prev = auditingRows[index - 1];
        crypto.encryptDataStorage("searchpatient", prev.paciente_id);
        updateAuditoria({
          selectedRow: prev,
          selectionModel: [prev.tratamiento_id],
        });
      }
    }
  };
};
